/* MARMOT: каталог (Порция 8.1) – търсене, пилове, брояч, „Покажи още".
   Vanilla, defer; без Lumia AJAX. Филтрите работят върху ЗАРЕДЕНИТЕ карти
   (по решението от брифа – „филтрира видимите книги на момента").
   Възрастовите пилове са временни до слайдера #250: те четат data-age
   токените на картите, така че слайдерът после сменя само UI-а.
   При активен слайдер видимите карти се подреждат по възрастова
   релевантност (CSS order, виж apply) – първо почващите в диапазона,
   после по-ранните по близост; вторичен ключ остава изборът от дропдауна. */
(function () {
  'use strict';

  var root = document.querySelector('[data-marmot-catalog]');
  if (!root) return;

  var grid = root.querySelector('[data-marmot-grid]');
  var search = root.querySelector('[data-marmot-search]');
  var pills = Array.prototype.slice.call(root.querySelectorAll('[data-marmot-pill]'));
  var shownEl = root.querySelector('[data-marmot-shown]');
  var shownNum = root.querySelector('[data-marmot-shown-num]');
  var shownNote = root.querySelector('[data-marmot-shown-note]');
  var clearBtns = Array.prototype.slice.call(root.querySelectorAll('[data-marmot-clear]'));
  var empty = root.querySelector('[data-marmot-empty]');
  var moreWrap = root.querySelector('[data-marmot-more-wrap]');
  var moreBtn = root.querySelector('[data-marmot-more]');
  var sortSel = root.querySelector('[data-marmot-sort]');
  var total = parseInt(root.getAttribute('data-total'), 10) || 0;
  var catalogLogic = window.MarmotCatalogLogic;
  var hasCatalogLogic = !!(catalogLogic && typeof catalogLogic.resolveInitialRange === 'function');
  var initialParams = null;
  try { initialParams = new URLSearchParams(window.location.search); } catch (e) { /* стар браузър */ }

  var presetAge = parseInt(root.getAttribute('data-marmot-age-start'), 10);
  var resetRange = { aMin: 1, aMax: 11, fromURL: false };
  var initialRange = resetRange;
  if (hasCatalogLogic) {
    resetRange = catalogLogic.resolveInitialRange(presetAge, null);
    initialRange = catalogLogic.resolveInitialRange(presetAge, initialParams);
  }

  /* Слайдер (по визията): скала 1..11, 11 = „11+". */
  var slider = root.querySelector('[data-marmot-slider]');
  var rMin = root.querySelector('[data-marmot-age-min]');
  var rMax = root.querySelector('[data-marmot-age-max]');
  var sFill = root.querySelector('[data-marmot-slider-fill]');
  var bubMin = root.querySelector('[data-marmot-bubble-min]');
  var bubMax = root.querySelector('[data-marmot-bubble-max]');
  var ticks = Array.prototype.slice.call(root.querySelectorAll('[data-marmot-tick]'));
  var rangeLabel = root.querySelector('[data-marmot-range-label]');

  var state = { q: '', age: '', type: '', aMin: initialRange.aMin, aMax: initialRange.aMax };
  var pendingAll = false;

  function ageLbl(v) { return v === 11 ? '11+' : String(v); }
  function sliderActive() { return !!slider && (state.aMin > 1 || state.aMax < 11); }
  function filtersActive() { return !!(state.q.trim() || state.age || state.type || sliderActive()); }

  function updateSlider() {
    if (!slider) return;
    var pctMin = ((state.aMin - 1) / 10) * 100;
    var pctMax = ((state.aMax - 1) / 10) * 100;
    if (sFill) {
      sFill.style.left = pctMin + '%';
      sFill.style.right = (100 - pctMax) + '%';
    }
    if (bubMin) { bubMin.style.left = pctMin + '%'; bubMin.textContent = ageLbl(state.aMin); }
    if (bubMax) { bubMax.style.left = pctMax + '%'; bubMax.textContent = ageLbl(state.aMax); }
    ticks.forEach(function (t) {
      var v = parseInt(t.getAttribute('data-value'), 10);
      t.classList.toggle('is-in', v >= state.aMin && v <= state.aMax);
    });
    if (rangeLabel) {
      if (!sliderActive()) rangeLabel.textContent = 'всички възрасти';
      else if (state.aMin === state.aMax) rangeLabel.textContent = ageLbl(state.aMin) + ' години';
      else rangeLabel.textContent = 'от ' + state.aMin + ' до ' + ageLbl(state.aMax) + ' г.';
    }
  }

  function items() {
    return grid ? Array.prototype.slice.call(grid.querySelectorAll('.marmot-catalog__item')) : [];
  }

  /* true, ако някой от токените в match присъства в attr (списъци през интервал). */
  function hasToken(attr, match) {
    if (!match) return true;
    var have = (attr || '').split(/\s+/);
    return match.split(/\s+/).some(function (m) {
      return m && have.indexOf(m) !== -1;
    });
  }

  function apply() {
    var q = state.q.trim().toLowerCase();
    var rankAge = sliderActive();
    var shown = 0;
    items().forEach(function (el) {
      var ok = true;
      if (q) {
        var hay = (el.getAttribute('data-title') || '') + ' ' + (el.getAttribute('data-author') || '');
        ok = hay.indexOf(q) !== -1;
      }
      if (ok && state.age) ok = hasToken(el.getAttribute('data-age'), state.age);
      if (ok && sliderActive()) {
        // Книга без възрастови данни минава само при пълен диапазон.
        var iMin = parseInt(el.getAttribute('data-age-min'), 10);
        var iMax = parseInt(el.getAttribute('data-age-max'), 10);
        ok = !isNaN(iMin) && !isNaN(iMax) && iMin <= state.aMax && iMax >= state.aMin;
      }
      if (ok && state.type) ok = hasToken(el.getAttribute('data-type'), state.type);
      if (ok) {
        el.removeAttribute('hidden');
        shown++;
      } else {
        el.setAttribute('hidden', '');
      }

      /* Релевантност при активен слайдер – CSS order върху грид клетките,
         без местене на DOM възли (lazy-load и анимациите остават на място).
         0 = книгата почва в избрания диапазон; иначе с колко години по-рано
         почва (при избрано 4: 3+ → 1, 2+ → 2, 1+ → 3). При равен ранг гридът
         пази DOM реда = подреждането от дропдауна. Без слайдер: order пада
         и оригиналният ред се връща. */
      if (ok && rankAge) {
        var startAge = parseInt(el.getAttribute('data-age-min'), 10);
        el.style.order = startAge >= state.aMin ? 0 : state.aMin - startAge;
      } else if (el.style.order) {
        el.style.order = '';
      }
    });

    if (shownNum) shownNum.textContent = shown;
    else if (shownEl) shownEl.textContent = 'Показани ' + shown + ' от ' + total;
    if (shownNote) shownNote.textContent = pendingAll ? ' · зареждам още…' : '';
    // Празното състояние чака да се дозаредят всички страници.
    if (empty) empty.hidden = shown !== 0 || pendingAll;

    /* Видимостта на „Изчисти филтрите" се мери спрямо НАЧАЛНОТО състояние на
       страницата: възрастовата колекция се отваря с активен слайдер, но там
       още няма какво да се чисти. `filtersActive()` остава за дотеглянето. */
    var active = hasCatalogLogic && typeof catalogLogic.hasClearableState === 'function'
      ? catalogLogic.hasClearableState(state, resetRange)
      : filtersActive();
    clearBtns.forEach(function (b) {
      if (b.hasAttribute('data-marmot-clear-auto')) b.hidden = !active;
    });
  }

  function setGroup(group, match) {
    state[group] = match || '';
    pills.forEach(function (p) {
      if (p.getAttribute('data-group') !== group) return;
      var mine = p.getAttribute('data-match') || '';
      p.setAttribute('aria-pressed', mine === state[group] ? 'true' : 'false');
    });
  }

  /* Дотегля една страница: добавя картите, връща href на следващата (или null). */
  function fetchPage(url) {
    return fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelectorAll('.marmot-catalog__item');
        Array.prototype.forEach.call(incoming, function (el) {
          grid.appendChild(document.importNode(el, true));
        });
        var next = doc.querySelector('[data-marmot-more]');
        return next ? next.getAttribute('href') : null;
      });
  }

  /* При активен филтър дозарежда ВСИЧКИ оставащи страници – иначе пил
     „Комикси" би показал „няма книги", ако комиксите са на страница 3. */
  function ensureAllLoaded() {
    if (!filtersActive()) return;
    if (pendingAll || !moreBtn || !moreWrap || moreWrap.hidden) return;
    pendingAll = true;
    moreBtn.setAttribute('aria-busy', 'true');
    (function step() {
      var url = moreBtn.getAttribute('href');
      if (!url) {
        moreWrap.hidden = true;
        finish();
        return;
      }
      fetchPage(url).then(function (next) {
        if (next) {
          moreBtn.setAttribute('href', next);
          apply();
          step();
        } else {
          moreWrap.hidden = true;
          finish();
        }
      }, finish);
    })();
    function finish() {
      pendingAll = false;
      moreBtn.removeAttribute('aria-busy');
      apply();
    }
  }

  pills.forEach(function (p) {
    p.addEventListener('click', function () {
      var group = p.getAttribute('data-group');
      var match = p.getAttribute('data-match') || '';
      var isActive = p.getAttribute('aria-pressed') === 'true';
      // Повторен клик върху активен пил = връщане към „Всички".
      setGroup(group, isActive ? '' : match);
      ensureAllLoaded();
      apply();
    });
  });

  if (rMin && rMax) {
    /* Числата под слайдера: първи клик мести по-близкия плъзгач; клик
       върху стойност, на която вече стои плъзгач, мести ДРУГИЯ – така
       диапазонът се управлява само с натискане, без провлачване. */
    function pickValue(v) {
      if (v < 1) v = 1;
      if (v > 11) v = 11;
      if (v === state.aMin && v === state.aMax) return;
      if (v === state.aMin) {
        state.aMax = v;
      } else if (v === state.aMax) {
        state.aMin = v;
      } else if (Math.abs(v - state.aMin) <= Math.abs(v - state.aMax)) {
        state.aMin = Math.min(v, state.aMax);
      } else {
        state.aMax = Math.max(v, state.aMin);
      }
      rMin.value = state.aMin;
      rMax.value = state.aMax;
      updateSlider();
      ensureAllLoaded();
      apply();
    }

    /* Клик/тап по лентата: мести ПО-БЛИЗКОТО кръгче до най-близкото
       деление. При равна отдалеченост (вкл. двете кръгчета едно върху
       друго): клик надясно от горното мести горното (max), иначе долното
       (min). Стойността влиза през input събитието на съответния range –
       същият път като влаченето (клампване, филтър, надпис, брояч). */
    function pickTrack(v) {
      if (v < 1) v = 1;
      if (v > 11) v = 11;
      if (v === state.aMin && v === state.aMax) return;
      var dMin = Math.abs(v - state.aMin);
      var dMax = Math.abs(v - state.aMax);
      var inp;
      if (dMin < dMax) {
        inp = rMin;
      } else if (dMax < dMin) {
        inp = rMax;
      } else {
        inp = v > state.aMax ? rMax : rMin;
      }
      inp.value = v;
      inp.dispatchEvent(new Event('input', { bubbles: true }));
    }

    rMin.addEventListener('input', function () {
      var v = parseInt(rMin.value, 10) || 1;
      if (v > state.aMax) v = state.aMax;
      rMin.value = v;
      state.aMin = v;
      updateSlider();
      ensureAllLoaded();
      apply();
    });
    rMax.addEventListener('input', function () {
      var v = parseInt(rMax.value, 10) || 11;
      if (v < state.aMin) v = state.aMin;
      rMax.value = v;
      state.aMax = v;
      updateSlider();
      ensureAllLoaded();
      apply();
    });
    // Числата под слайдера.
    ticks.forEach(function (t) {
      t.addEventListener('click', function () {
        pickValue(parseInt(t.getAttribute('data-value'), 10));
      });
    });
    // Клик директно по лентата (pickTrack): позицията се смята от
    // реалната геометрия на track елемента, не на целия контейнер.
    // Клик върху самия палец без влачене също минава оттук – no-op е,
    // защото по-близкото кръгче вече стои на стойността.
    var track = slider ? slider.querySelector('.marmot-catalog__slider-track') : null;
    if (track) {
      var downX = null;
      [rMin, rMax].forEach(function (inp) {
        inp.addEventListener('pointerdown', function (e) { downX = e.clientX; });
      });
      track.addEventListener('click', function (e) {
        var onThumb = e.target === rMin || e.target === rMax;
        // След реално влачене click събитието се пропуска.
        if (onThumb && downX !== null && Math.abs(e.clientX - downX) >= 5) return;
        var r = track.getBoundingClientRect();
        if (!r.width) return;
        var frac = (e.clientX - r.left) / r.width;
        pickTrack(Math.round(frac * 10) + 1);
      });
    }
    // „всички възрасти" винаги отваря изрично целия диапазон 1–11.
    if (rangeLabel) {
      rangeLabel.addEventListener('click', function () {
        if (!sliderActive()) return;
        state.aMin = 1;
        state.aMax = 11;
        rMin.value = 1;
        rMax.value = 11;
        updateSlider();
        apply();
      });
    }
  }

  if (search) {
    search.addEventListener('input', function () {
      state.q = search.value || '';
      ensureAllLoaded();
      apply();
    });
    // Enter не праща форма никъде – филтърът е на живо.
    search.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') e.preventDefault();
    });
  }

  clearBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      if (search) search.value = '';
      state.q = '';
      setGroup('age', '');
      setGroup('type', '');
      /* „Изчисти" връща началното състояние на страницата: пресета на
         възрастовата колекция, а в обикновения каталог — целия диапазон. */
      state.aMin = resetRange.aMin;
      state.aMax = resetRange.aMax;
      if (rMin) rMin.value = resetRange.aMin;
      if (rMax) rMax.value = resetRange.aMax;
      updateSlider();
      apply();
    });
  });

  if (sortSel) {
    sortSel.addEventListener('change', function () {
      if (sortSel.form) sortSel.form.submit();
    });
  }

  /* „Покажи още": дотегля следващата страница, влива само картите. */
  if (moreBtn) {
    moreBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var url = moreBtn.getAttribute('href');
      if (!url || moreBtn.getAttribute('aria-busy') === 'true') return;
      var label = moreBtn.textContent;
      moreBtn.setAttribute('aria-busy', 'true');
      moreBtn.textContent = 'Зареждам…';

      fetchPage(url)
        .then(function (next) {
          if (next) {
            moreBtn.setAttribute('href', next);
          } else if (moreWrap) {
            moreWrap.hidden = true;
          }
          moreBtn.textContent = label;
          moreBtn.removeAttribute('aria-busy');
          apply();
        })
        .catch(function () {
          // При проблем – нормална навигация към страница 2.
          window.location.href = url;
        });
    });
  }

  /* Начално състояние от пресета на колекцията и URL параметри. URL печели,
     за да могат външни линкове
     (възрастовите бутони и категорийните банери на хоума) да отворят
     каталога с готов филтър:
     ?age_min=3&age_max=6  → слайдерът застава на 3–6;
     ?type=komplekti       → избран тип-пил (токенът = data-match на пила).
     Двата параметъра се комбинират. Пресетът не дотегля всички страници —
     колекцията вече съдържа правилните книги; URL филтрите запазват старото
     дотегляне, защото могат да търсят съвпадения и на следващи страници. */
  (function initFromURL() {
    var params = initialParams;
    var changed = !!initialRange.fromURL || initialRange.aMin > 1 || initialRange.aMax < 11;
    var urlChanged = !!initialRange.fromURL;

    /* Ако чистата логика не се е заредила, пазим старото поведение: без
       пресет, но URL диапазоните продължават да работят и страницата не гърми. */
    if (!hasCatalogLogic && params) {
      var aMin = parseInt(params.get('age_min'), 10);
      var aMax = parseInt(params.get('age_max'), 10);
      if (!isNaN(aMin) || !isNaN(aMax)) {
        if (isNaN(aMin)) aMin = 1;
        if (isNaN(aMax)) aMax = 11;
        aMin = Math.min(Math.max(aMin, 1), 11);
        aMax = Math.min(Math.max(aMax, 1), 11);
        if (aMin > aMax) { var tmp = aMin; aMin = aMax; aMax = tmp; }
        state.aMin = aMin;
        state.aMax = aMax;
        changed = true;
        urlChanged = true;
      }
    }

    if (params) {
      var type = params.get('type');
      if (type) { setGroup('type', type); changed = true; urlChanged = true; }

      var ageTok = params.get('age');
      if (ageTok) { setGroup('age', ageTok); changed = true; urlChanged = true; }
    }

    if (rMin) rMin.value = state.aMin;
    if (rMax) rMax.value = state.aMax;
    updateSlider();
    if (urlChanged) ensureAllLoaded();
    if (changed) apply();
  })();
})();
